import { Box } from '@mui/material';
import { CAROUSEL_AUTO_PLAY_SPEED } from 'app/constants';
import { RankedLeaderboardsEntity } from 'app/interfaces/entity';
import { range } from 'lodash';
import { LeaderboardCarouselSlide } from 'modules/leaderboards/components/LeaderboardCarouselSlide';
import { CAROUSEL_RESPONSIVE } from 'modules/leaderboards/constants';
import { CarouselContext } from 'shared/providers';
import React, { FC, useContext, useEffect, useState } from 'react';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

interface LeaderboardsCarouselContentProps {
  leaderboard: RankedLeaderboardsEntity | null;
  slidesCount: number;
  autoPlay: boolean;
}

export const LeaderboardsCarouselContent: FC<LeaderboardsCarouselContentProps> = ({
  leaderboard,
  slidesCount,
  autoPlay,
}) => {
  const [carousel, setCarousel] = useState<Carousel | null>();
  const { activeSlide, setActiveSlide } = useContext(CarouselContext);

  useEffect(() => {
    carousel?.goToSlide(activeSlide);
  }, [carousel, activeSlide]);

  if (!slidesCount) {
    return null;
  }

  return (
    <Carousel
      infinite
      autoPlay={autoPlay && slidesCount > 1}
      afterChange={(_, state) => setActiveSlide(state.currentSlide)}
      ref={(el) => setCarousel(el)}
      responsive={CAROUSEL_RESPONSIVE}
      autoPlaySpeed={CAROUSEL_AUTO_PLAY_SPEED}
      arrows={false}
    >
      {range(0, slidesCount).map((slide) => (
        <Box key={slide}>
          <LeaderboardCarouselSlide
            mostWin={leaderboard?.mostWin[slide]}
            biggestWin={leaderboard?.biggestWin[slide]}
            mostPlayedGames={leaderboard?.mostGamesPlayed[slide]}
          />
        </Box>
      ))}
    </Carousel>
  );
};
